<template>
  <v-sheet tag="section" :class="$vuetify.breakpoint.smAndDown? 'mb-8' : 'mb-15'">
    <v-row class="form-item-heading" :class="headingBgColor">
      <v-subheader
        v-if="title"
        class="text-subtitle-1 align-center"
        :class="[
         headingTextColor ? `${headingTextColor}--text` : null,
         headingPadding, {'font-weight-bold': isHeadingTextBold}
        ]">
        {{ title }}
        <small v-if="annotation" :class="{'font-weight-bold': $vuetify.breakpoint.mdAndUp}">{{ annotation }}</small>
      </v-subheader>
    </v-row>
    <slot/>
  </v-sheet>
</template>

<script>
export default {
  name: "vb-form-section",
  props: {
    title: {type: String, required: false},
    required: {type: Boolean, default: false, required: false},
    annotation: {type: String, default: null, required: false}
  },
  computed: {
    isCharibon() {
      return this.$siteCode === VueConfig.siteCode.charibon;
    },
    headingBgColor() {
      return this.isHeadingTextBold ? 'transparent' : 'accent3';
    },
    headingTextColor() {
      return this.isHeadingTextBold ? 'primaryTextColor' : 'white';
    },
    headingPadding() {
      return this.$vuetify.breakpoint.mdAndUp ? 'pa-0' : 'pa-0 pl-4';
    },
    isHeadingTextBold() {
      return this.isCharibon || this.$vuetify.breakpoint.mdAndUp;
    },
  }
}
</script>

<style scoped lang="scss">
.row {
  margin-top: 0;
  margin-bottom: 0;
}
</style>